import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { IInspection } from 'app/shared/model/inspection.model';
import { getEntities as getInspections } from 'app/entities/inspection/inspection.reducer';
import { getEntity, updateEntity, createEntity, reset } from './inspection-history.reducer';
import { IInspectionHistory } from 'app/shared/model/inspection-history.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const InspectionHistoryUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const users = useAppSelector(state => state.userManagement.users);
  const inspections = useAppSelector(state => state.inspection.entities);
  const inspectionHistoryEntity = useAppSelector(state => state.inspectionHistory.entity);
  const loading = useAppSelector(state => state.inspectionHistory.loading);
  const updating = useAppSelector(state => state.inspectionHistory.updating);
  const updateSuccess = useAppSelector(state => state.inspectionHistory.updateSuccess);

  const handleClose = () => {
    props.history.push('/inspection-history' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getTruckImplements({}));
    dispatch(getUsers({}));
    dispatch(getInspections({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.created = convertDateTimeToServer(values.created);

    const entity = {
      ...inspectionHistoryEntity,
      ...values,
      truckImplement: truckImplements.find(it => it.id.toString() === values.truckImplementId.toString()),
      user: users.find(it => it.id.toString() === values.userId.toString()),
      inspection: inspections.find(it => it.id.toString() === values.inspectionId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          created: displayDefaultDateTime(),
        }
      : {
          status: 'NOT_COMPLIANT',
          ...inspectionHistoryEntity,
          created: convertDateTimeFromServer(inspectionHistoryEntity.created),
          truckImplementId: inspectionHistoryEntity?.truckImplement?.id,
          userId: inspectionHistoryEntity?.user?.id,
          inspectionId: inspectionHistoryEntity?.inspection?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.inspectionHistory.home.createOrEditLabel" data-cy="InspectionHistoryCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.inspectionHistory.home.createOrEditLabel">Create or edit a InspectionHistory</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="inspection-history-id" label={translate('global.field.id')} validate={{ required: true }} />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.inspectionHistory.created')}
                id="inspection-history-created"
                name="created"
                data-cy="created"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fleetSenseApp.inspectionHistory.status')}
                id="inspection-history-status"
                name="status"
                data-cy="status"
                type="select"
              >
                <option value="NOT_COMPLIANT">{translate('fleetSenseApp.InspectionStatus.NOT_COMPLIANT')}</option>
                <option value="COMPLIANT">{translate('fleetSenseApp.InspectionStatus.COMPLIANT')}</option>
                <option value="MAINTENANCE">{translate('fleetSenseApp.InspectionStatus.MAINTENANCE')}</option>
              </ValidatedField>
              <ValidatedField
                id="inspection-history-truckImplement"
                name="truckImplementId"
                data-cy="truckImplement"
                label={translate('fleetSenseApp.inspectionHistory.truckImplement')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField id="inspection-history-user" name="userId" data-cy="user" label={translate('fleetSenseApp.inspectionHistory.user')} type="select">
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="inspection-history-inspection"
                name="inspectionId"
                data-cy="inspection"
                label={translate('fleetSenseApp.inspectionHistory.inspection')}
                type="select"
              >
                <option value="" key="0" />
                {inspections
                  ? inspections.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/inspection-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default InspectionHistoryUpdate;
